/*
 * Print setup — implementation-plan.md §5.
 * Geometry (band = full usable page width, derived pixel step) is computed in
 * render/, not here: what is left is the chrome removal and the page breaks.
 */

/*
 * The `@page` rule is injected at runtime by render/page-setup.ts: orientation
 * and margins follow the print settings, and `@page` cannot be scoped to a
 * class. The standalone export writes its own copy, since it is printed with no
 * app around it.
 */

@media print {
  /* Category semantics rest entirely on coloured bars: without backgrounds the
     output carries no information. Firefox may still require "Print backgrounds"
     in the print dialog — verify on the first printed page (plan §5.4). */
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  body {
    margin: 0;
    background: #fff;
  }

  /* Everything that exists to edit the chart disappears.
     */
  .app-chrome,
  .editor,
  .fab,
  dialog,
  #document,
  .del-btn,
  /* The legend goes too: it is a way of looking, and on a sheet where space is
     the scarce thing, two lines of filter chrome are two lines of chart lost. */
  #legend {
    display: none !important;
  }

  .band {
    break-inside: avoid;
  }

}
